import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

// convert display info booleans into type strings
// so that messages can use select
export const getPriceMessagesTypes = pricingDisplayInfo => {
    // for onHoldLabel message
    let holdType;
    if (pricingDisplayInfo.showOnHoldCustom) {
        holdType = 'ON_HOLD_CUSTOM';
    } else if (pricingDisplayInfo.showOnHold) {
        holdType = 'ON_HOLD';
    }

    // for textPriceValue && priceLabel messages
    let textPriceType;
    if (pricingDisplayInfo.showSold) {
        textPriceType = 'sold';
    } else if (pricingDisplayInfo.showUnavailable) {
        textPriceType = 'unavailable';
    } else if (pricingDisplayInfo.showPUR) {
        textPriceType = 'pur';
    }

    return { holdType, textPriceType };
};

export const onHoldLabel = holdType => (
    <FormattedMessage
        values={{ holdType }}
        id="pdpPriceMessages.onHoldLabel"
        defaultMessage={`{holdType, select,
                ON_HOLD {On Hold}
                ON_HOLD_CUSTOM {On Hold For You}
                other {}
            }`}
    />
);

export const textPriceValue = textPriceType => (
    <FormattedMessage
        values={{ textPriceType }}
        id="pdpPriceMessages.textPriceValue"
        defaultMessage={`{textPriceType, select,
            sold {Sold}
            unavailable {Unavailable}
            pur {Price Upon Request}
            other {}
        }`}
    />
);

export const priceLabel = type => (
    <FormattedMessage
        values={{ type }}
        id="pdpPriceMessages.label"
        defaultMessage={`{type, select,
            NET {Net Price}
            RETAIL {List Price}
            PRIVATE_OFFER {Private Offer}
            other {}
        }`}
    />
);

export const discountLabel = discount => (
    <FormattedMessage
        values={{ discount: <FormattedNumber style="percent" value={discount} /> }}
        id="pdpPriceMessages.discount"
        defaultMessage="{discount} Off"
    />
);
